import { useState, useCallback, useEffect } from 'react';

/**
 * Hook for managing method synchronization
 * Single responsibility: Method dropdown synchronization
 */
export const useMethodSync = (currentMethod?: string) => {
    const [methodSyncCallback, setMethodSyncCallback] = useState<((method: string) => void) | null>(null);

    // Effect to sync method when it changes
    useEffect(() => {
        if (methodSyncCallback && currentMethod) {
            methodSyncCallback(currentMethod);
        }
    }, [currentMethod, methodSyncCallback]);

    const registerMethodSyncCallback = useCallback((callback: (method: string) => void) => {
        setMethodSyncCallback(() => callback);
    }, []);

    return {
        registerMethodSyncCallback,
    };
};

export type UseMethodSyncReturn = ReturnType<typeof useMethodSync>;
